import { render, staticRenderFns } from "./SortSelect.vue?vue&type=template&id=3dc4d3e3"
import script from "./SortSelect.vue?vue&type=script&lang=js"
export * from "./SortSelect.vue?vue&type=script&lang=js"
import style0 from "./SortSelect.vue?vue&type=style&index=0&id=3dc4d3e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports